var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 4.35C2.25 3.1902 3.1902 2.25 4.35 2.25H19.65C20.8098 2.25 21.75 3.19021 21.75 4.35V19.65C21.75 20.8098 20.8098 21.75 19.65 21.75H4.35C3.19021 21.75 2.25 20.8098 2.25 19.65V4.35ZM4.35 3.75C4.01863 3.75 3.75 4.01863 3.75 4.35V19.65C3.75 19.9814 4.01862 20.25 4.35 20.25H19.65C19.9814 20.25 20.25 19.9814 20.25 19.65V4.35C20.25 4.01862 19.9814 3.75 19.65 3.75H4.35Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75 3C6.75 2.58579 7.08579 2.25 7.5 2.25H16C16.4142 2.25 16.75 2.58579 16.75 3V12C16.75 12.4142 16.4142 12.75 16 12.75H7.5C7.08579 12.75 6.75 12.4142 6.75 12V3ZM8.25 3.75V11.25H15.25V3.75H8.25Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 5.75C13.4142 5.75 13.75 6.08579 13.75 6.5V8.5C13.75 8.91421 13.4142 9.25 13 9.25C12.5858 9.25 12.25 8.91421 12.25 8.5V6.5C12.25 6.08579 12.5858 5.75 13 5.75Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.74841 3C4.74841 2.58579 5.0842 2.25 5.49841 2.25H17.9992C18.4134 2.25 18.7492 2.58579 18.7492 3C18.7492 3.41421 18.4134 3.75 17.9992 3.75H5.49841C5.0842 3.75 4.74841 3.41421 4.74841 3Z",
    fill: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.592c93ddc2acce0db62ce1398fed093a.svg";
export { ForwardRef as ReactComponent };